/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>推荐用户资料</el-breadcrumb-item>
      <el-breadcrumb-item>产品推荐新增</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        
        
		<el-form label-width="120px" ref="editForm" :model="formProInfo" class="editForm">
		  <el-form-item label="文件名称" prop="productName">
		    <el-input size="small" v-model="formProInfo.name" auto-complete="off" placeholder="请输入产品名称"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="产品分类" :prop="formProInfo.recommendTypeId">
		    <el-select size="small" v-model="formProInfo.recommendTypeId" placeholder="请选择">
		        <el-option v-for="(item,index) in typeList1" :label="item.name" :value="item.id"></el-option>
		     </el-select>
		  </el-form-item>
		  
		  <el-form-item label="序号" prop="sortNumber">
		    <el-input size="small" v-model="formProInfo.sortNumber" auto-complete="off" placeholder="请输入序号,数字越小越靠前，整数"></el-input>
		  </el-form-item>
		 
		  <el-form-item label="状态" :prop="formProInfo.active">
		    <el-radio v-model="formProInfo.active" label="1">启用</el-radio>
		    <el-radio v-model="formProInfo.active" label="0">禁用</el-radio>
		  </el-form-item>
		  
		  <el-form-item   label="列表封面">
		    
		    <el-upload
		      class="upload-demo"
		      :action="uploadUrl()"
		      :http-request="customUpload2"
		      :on-preview="handlePreview2"
		      :on-remove="handleRemove2"
		      :file-list="resultFilelist2"
		      :limit='1'
		      accept=".png,.jpg,.jpeg"
		      list-type="picture-card">
		  			  <div slot="file" slot-scope="{file}">
		  			  	  <el-progress type="circle" :percentage="progressPercent2" v-if="isUpload2"></el-progress>
		  			       <img
		  			         class="el-upload-list__item-thumbnail"
		  			         :src="file.url" alt=""
		  			       >
		  			       <span class="el-upload-list__item-actions">
		  			         <!-- <span
		  			           class="el-upload-list__item-preview"
		  			           @click="handlePictureCardPreview(file)"
		  			         >
		  			           <i class="el-icon-zoom-in"></i>
		  			         </span> -->
		  			         
		  			         <span
		  			           class="el-upload-list__item-delete"
		  			           @click="handleRemove2(file)"
		  			         >
		  			           <i class="el-icon-delete"></i>
		  			         </span>
		  			       </span>
		  			   </div>
		      <el-button size="small" type="primary">点击上传图片</el-button>
		      <div slot="tip" class="el-upload__tip">建议尺寸110x80px，只能上传jpg、jpeg、png 图片，最多可上传1张图片</div>
		    </el-upload>
		    
		  </el-form-item>
		  
		  <el-form-item   label="产品图片">
		    
		    <el-upload
		      class="upload-demo"
		      :action="uploadUrl()"
		      :http-request="customUpload1"
		      :on-preview="handlePreview1"
		      :on-remove="handleRemove1"
		      :file-list="resultFilelist1"
			  :disabled='isUpload1'
			  :before-upload="beforeupload"
		      accept=".png,.jpg,.jpeg"
		      list-type="picture-card">
			  <div slot="file" slot-scope="{file}">
				  <el-progress type="circle" :percentage="progressPercent1" v-if="isUpload1 && file.status != 'complete'"></el-progress>
			       <img
			         class="el-upload-list__item-thumbnail"
			         :src="file.url" alt=""
			       >
			       <span class="el-upload-list__item-actions">
			         <!-- <span
			           class="el-upload-list__item-preview"
			           @click="handlePictureCardPreview(file)"
			         >
			           <i class="el-icon-zoom-in"></i>
			         </span> -->
					 <span
					   class="el-upload-list__item-delete"
					   @click="confirmEdit1(file)"
					 >
					  图片排序：{{file.serialNumber}}
					 </span>
			         
			         <span
			           class="el-upload-list__item-delete"
			           @click="handleRemove1(file)"
			         >
			           <i class="el-icon-delete"></i>
			         </span>
			       </span>
			   </div>
		      <el-button size="small" type="primary" @click="tips">点击上传图片</el-button>
		      <div slot="tip" class="el-upload__tip">建议尺寸1100x800px，只能上传jpg、jpeg、png 图片</div>
		    </el-upload>
		    
		  </el-form-item>
		 
		 <el-form-item  label="产品简介">
		   <!-- accept=".png,.jpeg,.gif,.pdf,.jpg,.JPG" -->
		   <el-upload
		     class="upload-files"
		     v-model="diaFrom.list"
		     :on-exceed="handleExceed"
		     :on-preview="handlePreview"
		     :before-upload="beforeAvatarUpload"
		     :on-remove="handleRemove"
		     :on-success="onUploadSuccess"
		     :file-list="resultFilelist"
		     list-type="picture-card"
		     :action="uploadUrl()"
		     :http-request="customUpload"
		     accept=".png,.jpg,.jpeg">
			 <div slot="file" slot-scope="{file}">
			 	  <el-progress type="circle" :percentage="progressPercent" v-if="isUpload && file.status != 'complete'"></el-progress>
			      <img
			        class="el-upload-list__item-thumbnail"
			        :src="file.url" alt=""
			      >
			     <span class="el-upload-list__item-actions">
			        <!-- <span
			          class="el-upload-list__item-preview"
			          @click="handlePictureCardPreview(file)"
			        >
			          <i class="el-icon-zoom-in"></i>
			        </span> -->
			        <!-- <span
			          class="el-upload-list__item-preview"
			          @click="handlePictureCardPreview(file)"
			        >
			          序号：1
			        </span> -->
					<span
					  class="el-upload-list__item-delete"
					  @click="confirmEdit(file)"
					>
					 图片排序：{{file.serialNumber}}
					</span>
			        <span
			          class="el-upload-list__item-delete"
			          @click="handleRemove(file)"
			        >
			          <i class="el-icon-delete"></i>
			        </span>
			      </span>
				  
			  </div>
		     <el-button size="small" type="primary">点击上传文件</el-button>
		     <div slot="tip" class="el-upload__tip">仅支持上传图片</div>
		     
		   </el-upload>
		 </el-form-item>
		  
		  
		  
		  
		  
		</el-form>
		
		
		<div slot="footer" class="dialog-footer">
		  <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
		</div>
		
		<el-dialog
		  title="请填写图片序号"
		  :visible.sync="centerDialogVisible"
		  width="30%"
		  center>
		    <el-input size="small" v-model="imgsortNumber" auto-complete="off" placeholder="请输入序号,数字越小越靠前，整数"></el-input>
		
		  <span slot="footer" class="footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>
		
		
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getRecommendTypeList,
	  createRecommend,
	  getRecommendById,
	  updateRecommend
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		  centerDialogVisible:false,
		  isUpload: false,//文件是否上传中
		  progressPercent: 0,//进度条当前进度
		  isUpload1: false,//文件是否上传中
		  progressPercent1: 0,//进度条当前进度
		  isUpload2: false,//文件是否上传中
		  progressPercent2: 0,//进度条当前进度
          loading: false, //是显示加载
		  keytype:0,
          title: '导购分类新增',
		  typeList1:'',
          // 请求数据参数
          formProInfo: {
            // 分类名称(支持右模糊查询)
            name: '',
            //所属导购：1-导购知识视频；2-服务视频；3-导购文件
            category:1,
            //分类状态：0-禁用；1-启用
            active:'1',
			recommendTypeId:'',
			sortNumber:''
          },
		  diaFrom:{
		    desc:'',
		    list:[]
		  },
    	  id:'',
		  shuo:'',
         resultFilelist:[],
		 resultFilelist1:[],
		 resultFilelist2:[],
		 imgsortNumber:''
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)
		

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.shuo = this.$route.query.shuo
		 this.changetype()
		  if(this.shuo=='新增'){
			  this.title = '知识导购视频新增'
		  }else{
			  this.title = '知识导购视频编辑'
			  this.handleEdit()
		  }
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  tips(){
		  	if(this.isUpload1){
		  		this.$message.warning('图片还在上传')
		  	}
		  },
		  dealPDF(){
		      var liElements = document.querySelectorAll('ul.el-upload-list,el-upload-list--picture li.el-upload-list__item');
		      liElements.forEach(function(liElement){
		        var aElement = liElement.querySelector('a.el-upload-list__item-name');
		        if(aElement && (aElement.textContent.includes('.pdf') || aElement.textContent.includes('.doc') || aElement.textContent.includes('.docx') || aElement.textContent.includes('.ppt') || aElement.textContent.includes('.pptx'))){
		          var imgElement = liElement.querySelector('img.el-upload-list__item-thumbnail')
		          if(imgElement){
		            imgElement.src= require('../../assets/img/pdf.png');// 普换为你想要的新图片的URL
		          }
		        }
		      })
		  },
		  onUploadSuccess(response,file,fileList){
		    console.log('onUploadSuccess',response)
		    // if(response && response.code ==='APPLY_SUCCESS'){
		    //     if(response.data){
		    //       this.resultFilelist.push({
		    //           url:response.data.url,
		    //           name: response.data.name,
		    //           uid: file.uid
		    //       })
		    //       // this.dealPDF();
		    //       // setTimeout(()=>{
		    //       //   this.dealPDF();
		    //       // },1);
		    //     }
		    //   }else if (response && response.msg){ 
		    //     console.log('upload failed', response.msg);
		    //   }
		  },
		  beforeAvatarUpload(file){
		    return new Promise((resolve) => {
		    	this.$prompt('请输入序号', '提示', {
		    	  confirmButtonText: '确定',
		    	  cancelButtonText: '取消',
		    	  inputPattern: /^\d+$/,
		    	  inputErrorMessage: '序号格式不正确'
		    	}).then(({ value }) => {
		    	  // 将序号保存到文件对象中
		    	  file.serialNumber = Number(value)
		    	  resolve(true)
		    	}).catch(() => {
		    	  resolve(false)
		    	})
		      })  
		  },
		  
		  //限制上传个数不超过9个
		  handleExceed(files,fileList){
		    if(fileList && fileList.length == 1){
		      this.$message.warning('上传文件不可超过1个')
		    }
		  },
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getRecommendById(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         let data = res.data
		         this.formProInfo.name = data.name
		         this.formProInfo.active= String(data.active)
		         this.formProInfo.recommendTypeId= data.recommendTypeId
				 this.formProInfo.sortNumber= data.sortNumber
				 
				 this.resultFilelist1 = []
				 this.resultFilelist = []
				 this.resultFilelist2 = []
				 
				 
				 data.pictureInfoList.map((item,index)=>{
					 this.resultFilelist1.push({
						mediaObjInfo: item.mediaObjInfo,
						status:'complete',
						serialNumber:item.serialNumber,
						url:item.mediaObjInfo.fileTemporaryUrl,
					 })
				    //  this.resultFilelist1.push({
				    //    url:item.mediaObjInfo.fileTemporaryUrl,
				    //    fileTemporaryUrl:item.mediaObjInfo.fileTemporaryUrl,
				    //    fileId:item.mediaObjInfo.fileId,
				    //    name: item.mediaObjInfo.ossFile.fileName,
					   // status:'complete',
					   // serialNumber:item.serialNumber
				    //  })
				     
				 })
				 
				 
				 // this.resultFilelist1.push({
				 //   url:data.fileCoverInfo.fileTemporaryUrl,
				 //   fileTemporaryUrl:data.fileCoverInfo.fileTemporaryUrl,
				 //   fileId:data.fileCoverInfo.fileId,
				 //   name: data.fileCoverInfo.ossFile.fileName,
				 //   status:'complete'
				 // })
				 this.resultFilelist2.push({
				   url:data.listCoverInfo.fileTemporaryUrl,
				   fileTemporaryUrl:data.listCoverInfo.fileTemporaryUrl,
				   fileId:data.listCoverInfo.fileId,
				   name: data.listCoverInfo.ossFile.fileName,
				 })
				 
				data.briefIntroductionList.map((item,index)=>{
									 
					 this.resultFilelist.push({
						mediaObjInfo: item.mediaObjInfo,
						status:'complete',
						serialNumber:item.serialNumber,
						url:item.mediaObjInfo.fileTemporaryUrl,
					 })
					
				})
				   
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		  uploadUrl(){
		    return '/mtl/marking/api/main/oss-file/upload-file'
		  },
		  handlePreview(file){
		    console.log(file)
		   
		  },
		  handlePreview1(file){
		    console.log(file)
		   
		  },
		  handlePreview2(file){
		    console.log(file)
		   
		  },
		  customUpload(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
		    this.isUpload = true
		    this.progressPercent = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
				 
		        if(response.data.success){
					this.progressPercent = 100
					setTimeout(()=>{
						this.isUpload = false
					},1500)
		          let data = response.data.data
		          console.log(data)
		         _this.resultFilelist.push({
		                 url:data.fileTemporaryUrl,
		                 fileTemporaryUrl:data.fileTemporaryUrl,
		                 fileId:data.fileId,
		                 name: data.ossFile.fileName,
		                 uid: req.file.uid,
		                 mediaObjInfo:data,
						  status:'complete',
						  serialNumber:req.file.serialNumber || 0,
		             })
		          
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		  beforeupload(file){
			return new Promise((resolve) => {
				this.$prompt('请输入序号', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  inputPattern: /^\d+$/,
				  inputErrorMessage: '序号格式不正确'
				}).then(({ value }) => {
				  // 将序号保存到文件对象中
				  file.serialNumber = Number(value)
				  resolve(true)
				}).catch(() => {
				  resolve(false)
				})
			  })  
			 
		  },
		  confirmEdit(file) {
			  return new Promise((resolve) => {
			  	this.$prompt('请输入序号', '提示', {
			  	  confirmButtonText: '确定',
			  	  cancelButtonText: '取消',
			  	  inputPattern: /^\d+$/,
			  	  inputErrorMessage: '序号格式不正确'
			  	}).then(({ value }) => {
			  	  // 将序号保存到文件对象中
			  	  file.serialNumber = Number(value)
			  	  resolve(true)
			  	}).catch(() => {
			  	  resolve(false)
			  	})
			    })  
		       
		   },
		   confirmEdit1(file) {
			  return new Promise((resolve) => {
				this.$prompt('请输入序号', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  inputPattern: /^\d+$/,
				  inputErrorMessage: '序号格式不正确'
				}).then(({ value }) => {
				  // 将序号保存到文件对象中
				  file.serialNumber = Number(value)
				  resolve(true)
				}).catch(() => {
				  resolve(false)
				})
				})  
		        
		    },
		  customUpload1(req){
		    let _this = this
		    console.log(222,req)
			
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
		    this.isUpload1 = true
		    this.progressPercent1 = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
		  				 
		        if(response.data.success){
					
					let data = response.data.data
					console.log(data)
					this.progressPercent1 = 100
					setTimeout(()=>{
						this.isUpload1 = false
						_this.resultFilelist1.push({
						        url:data.fileTemporaryUrl,
						        fileTemporaryUrl:data.fileTemporaryUrl,
						        fileId:data.fileId,
						        name: data.ossFile.fileName,
						        uid: req.file.uid,
						        mediaObjInfo:data,
								status:'complete',
								serialNumber:req.file.serialNumber
						    })
					},1500)
		          
		         console.log(1500,_this.resultFilelist1)
		            
		          
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist1)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		  customUpload2(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
		    this.isUpload2 = true
		    this.progressPercent2 = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
		  				 
		        if(response.data.success){
		  					this.progressPercent2 = 100
		  					setTimeout(()=>{
		  						this.isUpload2 = false
		  					},1500)
		          let data = response.data.data
		          console.log(data)
		          _this.resultFilelist2.push({
		                  url:data.fileTemporaryUrl,
		                  fileTemporaryUrl:data.fileTemporaryUrl,
		                  fileId:data.fileId,
		                  name: data.ossFile.fileName,
		                  uid: req.file.uid,
		                  mediaObjInfo:data
		              })
		            
		          
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist2)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		  handleRemove(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
		     console.log(index)
		     this.resultFilelist.splice(index,1);
		  },
		  handleRemove1(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index2 = this.resultFilelist1.findIndex(item => item.fileId === file.fileId)
		     console.log(index2)
		     this.resultFilelist1.splice(index2,1);
		  },
		  handleRemove2(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index2 = this.resultFilelist2.findIndex(item => item.fileId === file.fileId)
		     console.log(index2)
		     this.resultFilelist2.splice(index2,1);
		  },
		//编辑
		goback() {
			this.$router.push({ path: '/prodrecommend'})
		 
		},
		
      
	  changetype(e){
		  console.log(123456,e)
		  //this.formProInfo.firstLevelId = e
		  let parm = {
		  		 category:1
		  }
		  getRecommendTypeList(parm).then(res => {
			console.log(123)
			this.loading = false
			if (res.success == false) {
			  this.$message({
				type: 'info',
				message: res.msg
			  })
			} else {
					this.typeList1 = res.data
			
			
			}
		  })
	  },
	 
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


        
        
        // 编辑、添加提交方法
        saveProInfo(){
            console.log(this.content)
             if(!this.formProInfo.name){
              return this.$message({
                      type: 'warning',
                      message: '请填写名称'
                    })
            }
			
			if(!this.formProInfo.recommendTypeId){
			  return this.$message({
			          type: 'warning',
			          message: '请选择分类！'
			        })
			}
			if(this.resultFilelist2.length==0){
				return this.$message({
				        type: 'warning',
				        message: '请上传列表封面！'
				      })
			}
			if(this.resultFilelist1.length==0){
				return this.$message({
				        type: 'warning',
				        message: '请上传产品封面！'
				      })
			}
			if(this.resultFilelist.length==0){
				return this.$message({
				        type: 'warning',
				        message: '请上传产品介绍！'
				  })
			}
			this.formProInfo.sortNumber = Number(this.formProInfo.sortNumber)
			let sortNumbertype = Number.isInteger(this.formProInfo.sortNumber)
			if(sortNumbertype==false){
			  return this.$message({
			          type: 'warning',
			          message: '请填写整数！'
			        })
			}
			
			
			this.formProInfo.briefIntroductionList = this.resultFilelist
			//this.formProInfo.fileCoverInfo = this.resultFilelist1[0].mediaObjInfo
			this.formProInfo.pictureInfoList = this.resultFilelist1
			this.formProInfo.listCoverInfo = this.resultFilelist2[0].mediaObjInfo
			if(this.formProInfo.sortNumber==''){
				this.formProInfo.sortNumber=null
			}
            if(this.shuo=='新增'){
				createRecommend(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				  }
				})
			}else{
				this.formProInfo.id = this.id
				console.log(1234444,this.formProInfo)
				updateRecommend(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				  }
				})
			}
          
    		
        },

       

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
       
        

      }
    }
    </script>

    <style scoped>
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
 
    </style>





// WEBPACK FOOTER //
// src/views/userprofile/prodrecommendadd.vue